// import React, { useContext, useEffect, useState } from 'react';
// import {
//   Box,
//   Typography,
//   Avatar,
//   Stack,
//   useMediaQuery,
//   Paper,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Chip,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
// import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
// import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
// import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
// import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
// import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
// import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
// import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import BadgeIcon from '@mui/icons-material/Badge';

// import { BASE_URL } from '../../Api/ApiUrls';
// import Bankimage from './../../../../src/Images/residencyimage1.png';
// import newLaunchImg from './../../../../src/Images/building.png';
// import sellPropertyImg from './../../../../src/Images/luxury.png';
// import rentPropertyImg from './../../../../src/Images/residencyimage1.png';
// import leasePropertyImg from './../../../../src/Images/padpen.png';
// import jdJvImg from './../../../../src/Images/jvjdbuilding.png';
// import requirementsImg from './../../../../src/Images/correctionpad.png';
// import bankActionImg from './../../../../src/Images/Bankimage.png';
// import img1 from './../../../Images/vendorcard.jpg';
// import defaultPropertyImg from './../../../Images/default.jpg';

// import FormsBottomNavbar from './FormsBottomNavbar';
// import SearchBar from './PostBack';
// import { AuthContext } from '../../AuthContext/AuthContext';


// // ======================================================
// // FORM OPTIONS
// // ======================================================
// const options = [
//   {
//     icon: ApartmentIcon,
//     centerText: "Best Deal Properties\n(Layouts, Villas, Apartment Flats)",
//     desc: "Discover the latest projects from top builders.",
//     buttonLabel: "Post Project",
//     featured: true,
//     badge: "Best",
//     path: "/postyourbestdeal-form",
//     image: Bankimage,  // Specific image for Best Deal
//   },
//   {
//     icon: ApartmentIcon,
//     centerText: "New Launching Properties\n(Layouts, Villas, Apartment Flats)",
//     desc: "Discover the latest projects from top builders.",
//     buttonLabel: "Post Project",
//     featured: true,
//     badge: "New Launch",
//     path: "/new-launching-prop-form",
//     image: newLaunchImg,  // Specific image for New Launch
//   },
//   {
//     icon: SellOutlinedIcon,
//     centerText: "Sell Your Property",
//     desc: "List your property for sale and connect with genuine buyers.",
//     buttonLabel: "Post Now",
//     path: "/sellyourproperty-form",
//     image: sellPropertyImg,  // Specific image for Sell
//   },
//   {
//     icon: HomeOutlinedIcon,
//     centerText: "Rent Your Property",
//     desc: "Find the right tenants quickly and rent with ease.",
//     buttonLabel: "Post Now",
//     path: "/rent-form",
//     image: rentPropertyImg,  // Specific image for Rent
//   },
//   {
//     icon: DescriptionOutlinedIcon,
//     centerText: "Lease Your Property",
//     desc: "Lease your residential or commercial property easily.",
//     buttonLabel: "Post Now",
//     path: "/lease-form",
//     image: leasePropertyImg,  // Specific image for Lease
//   },
//   {
//     icon: HandshakeOutlinedIcon,
//     centerText: "Post your JD/JV/Build Suit",
//     desc: "Find partners for Joint Development or Build to Suit projects.",
//     buttonLabel: "Post Now",
//     path: "/builder-registration-form",
//     image: jdJvImg,  // Specific image for JD/JV
//   },
//   {
//     icon: FactCheckOutlinedIcon,
//     centerText: "Post Your Requirements",
//     desc: "Tell us what you need. We'll find the best matches for you.",
//     buttonLabel: "Post Now",
//     path: "/pg-hostel-form",
//     image: requirementsImg,  // Specific image for Requirements
//   },
//   {
//     icon: GavelOutlinedIcon,
//     centerText: "Post Bank Action Properties",
//     desc: "List bank auction and distressed properties.",
//     buttonLabel: "Post Now",
//     path: "/post-bank-properties",
//     image: bankActionImg,  // Specific image for Bank Action
//   },
// ];

// // ======================================================
// // MAIN COMPONENT
// // ======================================================

// const Forms = () => {
//   const theme = useTheme();

//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isiPhoneSE = useMediaQuery(
//     '(max-width: 376px) and (max-height: 670px)'
//   );
//   const isSmallScreen = useMediaQuery('(max-width: 376px)');

//   const navigate = useNavigate();

//   // ======================================================
//   // STATE
//   // ======================================================

//   const [openModal, setOpenModal] = useState(false);
//   const [missingPlans, setMissingPlans] = useState([]);

//   const { userId, logout, isGuest } = useContext(AuthContext);


//   // ======================================================
//   // BACK
//   // ======================================================

//   const handleBackClick = () => navigate(-1);

//   useEffect(() => {
//     checkFreePlan();
//   }, []);

//   const checkFreePlan = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/check-free-plan/${userId}/`
//       );

//       if (!res.data.has_free_plan) {
//         setMissingPlans(
//           res.data.missing_free_user_types || []
//         );

//         setOpenModal(true);
//       }
//     } catch (error) {
//       console.error("Error checking free plan:", error);
//     }
//   };


//   // ======================================================
//   // CLAIM API
//   // ======================================================

//   const handleClaim = async () => {
//     try {
//       await axios.post(
//         `${BASE_URL}/claim-all-free-plans/`,
//         {
//           user_id: userId,
//         }
//       );

//       alert("✅ Free plans claimed successfully!");

//       setOpenModal(false);

//       checkFreePlan();

//     } catch (error) {
//       console.error("Error claiming free plans:", error);
//     }
//   };


//   // ======================================================
//   // UI COLORS 
//   // ======================================================

//   // Page background - from WorkerDetail: #f6f2e9
//   const PAGE_BACKGROUND = '#f6f2e9';

//   // Card background - from WorkerDetail: #F8F7F4
//   const CARD_BG = '#F8F7F4';

//   // Card border - from WorkerDetail: #e7e1d7
//   const CARD_BORDER = '#e7e1d7';

//   // Gold color - KEEP ORIGINAL
//   const GOLD = '#D9A441';
//   const GOLD_DARK = '#C48F2E';

//   const BADGE_DARK = '#171717';


//   // ======================================================
//   // RETURN
//   // ======================================================

//   return (
//     <>
//       {/* ==================================================
//           TOP SEARCH / HEADER
//       ================================================== */}

//       <SearchBar onBackClick={handleBackClick} />


//       {/* ==================================================
//           MAIN CONTENT
//       ================================================== */}
//       <Box
//         sx={{
//           px: isMobile ? 1 : 2,
//           pt: 2,
//           pb: 10,
//           mt: 8, 
          
//           width: '100%',
//           maxWidth: '100%',
          
//           mx: 'auto',
          
//           minHeight: isiPhoneSE
//             ? '100vh'
//             : '82vh',
          
//           backgroundColor: PAGE_BACKGROUND,  // #f6f2e9 from WorkerDetail
          
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
          
//           boxSizing: 'border-box',
//         }}
//       >

//         {/* ==================================================
//             CARDS
//         ================================================== */}

//         <Stack spacing={1}>

//           {options.map((item, index) => {

//             const Icon = item.icon;

//             return (

//               <Box
//                 key={index}
//                 onClick={() => navigate(item.path)}
//                 sx={{
//                   cursor: 'pointer',

//                   display: 'flex',
//                   alignItems: 'stretch',

//                   width: '100%',

//                   minWidth: 0,
//                 }}
//               >

//                 {/* ==================================================
//                     LEFT ICON SECTION
//                 ================================================== */}

//                 <Box
//                   sx={{
//                     width: 40,
//                     minWidth: 40,

//                     bgcolor: BADGE_DARK,

//                     borderRadius: '14px 0 0 14px',

//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',

//                     position: 'relative',

//                     zIndex: 2,

//                     boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
//                   }}
//                 >

//                   <Icon
//                     sx={{
//                       color: '#E1B84C',

//                       fontSize: isMobile
//                         ? 20
//                         : 22,

//                       strokeWidth: 1.2,
//                     }}
//                   />

//                 </Box>


//                 {/* ==================================================
//                     CARD - Using WorkerDetail card background
//                 ================================================== */}

//                 <Paper
//                   elevation={0}

//                   sx={{
//                     flexGrow: 1,

//                     minWidth: 0,

//                     display: 'flex',
//                     alignItems: 'center',

//                     gap: 1,

//                     p: 0.8,

//                     pl: 1,

//                     minHeight: isMobile
//                       ? 72
//                       : 76,

//                     borderRadius: '0 14px 14px 0',

//                     bgcolor: CARD_BG,  // #F8F7F4 from WorkerDetail

//                     border: `1px solid ${CARD_BORDER}`,  // #e7e1d7 from WorkerDetail

//                     boxShadow: '0 2px 8px rgba(0,0,0,0.10)',

//                     overflow: 'hidden',

//                     transition:
//                       'box-shadow 0.2s ease',

//                     ...(item.featured && {
//                       background: CARD_BG,
//                       border: `1px solid ${CARD_BORDER}`,
//                     }),

//                     '&:hover': {
//                       boxShadow: '0 3px 10px rgba(0,0,0,0.12)',
//                     },
//                   }}
//                 >


//                   {/* ==================================================
//                       PROPERTY IMAGE
//                   ================================================== */}

//                   <Box
//                     sx={{
//                       position: 'relative',

//                       flexShrink: 0,

//                       width: isMobile
//                         ? 60
//                         : 65,

//                       height: isMobile
//                         ? 60
//                         : 65,
//                     }}
//                   >

//                 <Avatar
//   variant="rounded"
//   src={item.image}  
//   alt={item.centerText}
//   sx={{
//     width: '100%',
//     height: '100%',
//     borderRadius: '10px',
//     border: 'none',
//     boxShadow: 'none',
//     objectFit: 'cover',
//     '& img': {
//       objectFit: 'cover',
//     },
//   }}
// />


//                     {/* ==================================================
//                         BADGE - KEEP ORIGINAL COLORS
//                     ================================================== */}

//                     {item.badge && (

//                       <Chip
//                         label={
//                           item.badge === 'New Launch'
//                             ? 'NEW'
//                             : item.badge
//                         }

//                         size="small"

//                         sx={{
//                           position: 'absolute',

//                           top: -4,
//                           right: -4,

//                           height: 16,

//                           minWidth: 26,

//                           fontSize: 7,

//                           fontWeight: 700,

//                           bgcolor: '#D9A441',  // KEEP ORIGINAL GOLD

//                           color: '#FFFFFF',

//                           borderRadius: '4px',

//                           '& .MuiChip-label': {
//                             px: 0.6,
//                             py: 0.3,
//                           },
//                         }}
//                       />

//                     )}

//                   </Box>


//                   {/* ==================================================
//                       TITLE + DESCRIPTION
//                   ================================================== */}

//                   <Box
//                     sx={{
//                       flexGrow: 1,

//                       minWidth: 0,

//                       overflow: 'hidden',

//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'center',
//                     }}
//                   >

//               <Box>
//   {/* First Line with underline ONLY on first word */}
//   <Box sx={{ display: 'inline-block' }}>
//     <Typography
//       sx={{
//         fontWeight: 700,
//         fontSize: isMobile ? '11px' : '12.5px',
//         color: '#171717',
//         lineHeight: 1.15,
//         letterSpacing: '-0.1px',
//         borderBottom: '2px solid #D9A441',
//         paddingBottom: '2px',
//         display: 'inline-block',
//       }}
//     >
//       {item.centerText.split('\n')[0].split(' ')[0]}
//     </Typography>
    
//     {/* Rest of first line - NO underline */}
//     <Typography
//       sx={{
//         fontWeight: 700,
//         fontSize: isMobile ? '11px' : '12.5px',
//         color: '#171717',
//         lineHeight: 1.15,
//         letterSpacing: '-0.1px',
//         display: 'inline',
//       }}
//     >
//       {item.centerText.split('\n')[0].substring(
//         item.centerText.split('\n')[0].split(' ')[0].length
//       )}
//     </Typography>
//   </Box>
  
//   {/* Second Line - NO underline */}
//   {item.centerText.includes('\n') && (
//     <Typography
//       sx={{
//         fontWeight: 700,
//         fontSize: isMobile ? '11px' : '12.5px',
//         color: '#171717',
//         lineHeight: 1.15,
//         letterSpacing: '-0.1px',
//         display: 'block',
//       }}
//     >
//       {item.centerText.split('\n')[1]}
//     </Typography>
//   )}
// </Box>

//                     {/* DESCRIPTION */}

//                     {item.desc && (

//                       <Typography
//                         sx={{
//                           fontSize: isMobile
//                             ? '8.5px'
//                             : '9.5px',

//                           color: '#555555',

//                           mt: 0.3,

//                           lineHeight: 1.2,

//                           display:
//                             '-webkit-box',

//                           WebkitLineClamp: 2,

//                           WebkitBoxOrient:
//                             'vertical',

//                           overflow: 'hidden',
//                         }}
//                       >
//                         {item.desc}
//                       </Typography>

//                     )}

//                   </Box>


//                   {/* ==================================================
//                       CTA BUTTON - KEEP ORIGINAL COLORS
//                   ================================================== */}

//                   <Button
//                     onClick={(e) => {

//                       e.stopPropagation();

//                       navigate(item.path);

//                     }}

//                     variant="contained"

//                     disableElevation

//                     sx={{
//                       flexShrink: 0,

//                       textTransform: 'none',

//                       fontWeight: 600,

//                       fontSize: isMobile
//                         ? '8.5px'
//                         : '9.5px',

//                       borderRadius: '6px',

//                       px: isMobile
//                         ? 1.2
//                         : 1.5,

//                       py: 0.5,

//                       minWidth: isMobile
//                         ? 60
//                         : 68,

//                       whiteSpace: 'nowrap',

//                       bgcolor: '#D49A25',  // KEEP ORIGINAL

//                       color: '#FFFFFF',

//                       boxShadow: '0 2px 5px rgba(180,120,20,0.25)',

//                       '&:hover': {
//                         bgcolor: '#C58B20',  // KEEP ORIGINAL
//                       },
//                     }}
//                   >
//                     {item.buttonLabel || 'Post Now'}
//                   </Button>

//                 </Paper>

//               </Box>

//             );

//           })}


//           {/* ==================================================
//               VENDOR REGISTRATION
//           ================================================== */}

//           <Box
//             onClick={() =>
//               navigate('/vendor-form')
//             }

//             sx={{
//               cursor: 'pointer',

//               display: 'flex',

//               alignItems: 'stretch',

//               width: '100%',

//               minWidth: 0,
//             }}
//           >

//             {/* ==================================================
//                 VENDOR ICON
//             ================================================== */}

//             <Box
//               sx={{
//                 width: 40,
//                 minWidth: 40,

//                 bgcolor: BADGE_DARK,

//                 borderRadius: '14px 0 0 14px',

//                 display: 'flex',

//                 alignItems: 'center',

//                 justifyContent: 'center',

//                 position: 'relative',

//                 zIndex: 2,

//                 boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
//               }}
//             >

//               <BadgeIcon
//                 sx={{
//                   color: '#E1B84C',

//                   fontSize: isMobile
//                     ? 20
//                     : 22,
//                 }}
//               />

//             </Box>


//             {/* ==================================================
//                 VENDOR CARD - Using WorkerDetail card background
//             ================================================== */}

//             <Paper
//               elevation={0}

//               sx={{
//                 flexGrow: 1,

//                 minWidth: 0,

//                 display: 'flex',

//                 alignItems: 'center',

//                 gap: 1,

//                 p: 0.8,

//                 pl: 1,

//                 minHeight: isMobile
//                   ? 72
//                   : 76,

//                 borderRadius: '0 14px 14px 0',

//                 bgcolor: CARD_BG,  // #F8F7F4 from WorkerDetail

//                 border: `1px solid ${CARD_BORDER}`,  // #e7e1d7 from WorkerDetail

//                 boxShadow: '0 2px 8px rgba(0,0,0,0.10)',

//                 overflow: 'hidden',

//                 transition:
//                   'box-shadow 0.2s ease',

//                 '&:hover': {
//                   boxShadow: '0 3px 10px rgba(0,0,0,0.12)',
//                 },
//               }}
//             >


//               {/* ==================================================
//                   VENDOR IMAGE
//               ================================================== */}

//               <Avatar
//                 src={img1}

//                 alt="Vendor"

//                 variant="rounded"

//                 sx={{
//                   width: isMobile
//                     ? 60
//                     : 65,

//                   height: isMobile
//                     ? 60
//                     : 65,

//                   borderRadius: '10px',

//                   border: 'none',

//                   boxShadow: 'none',

//                   flexShrink: 0,

//                   '& img': {
//                     objectFit: 'cover',
//                   },
//                 }}
//               />


//               {/* ==================================================
//                   VENDOR TEXT - KEEP ORIGINAL LINE COLOR
//               ================================================== */}

//               <Box
//                 sx={{
//                   flexGrow: 1,

//                   minWidth: 0,

//                   overflow: 'hidden',

//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'center',
//                 }}
//               >

//                <Box sx={{ display: 'inline-block' }}>
//   {/* "Vendors" - WITH underline */}
//   <Typography
//     sx={{
//       fontWeight: 700,
//       fontSize: isMobile ? '11px' : '12.5px',
//       color: '#171717',
//       lineHeight: 1.15,
//       borderBottom: '2px solid #D9A441',
//       paddingBottom: '2px',
//       display: 'inline-block',
//     }}
//   >
//     Vendors
//   </Typography>
  
//   {/* "Registration" - NO underline */}
//   <Typography
//     sx={{
//       fontWeight: 700,
//       fontSize: isMobile ? '11px' : '12.5px',
//       color: '#171717',
//       lineHeight: 1.15,
//       display: 'inline',
//     }}
//   >
//     {' '}Registration
//   </Typography>
// </Box>


//                 <Typography
//                   sx={{
//                     fontSize: isMobile
//                       ? '8.5px'
//                       : '9.5px',

//                     color: '#555555',

//                     mt: 0.3,

//                     lineHeight: 1.2,

//                     display:
//                       '-webkit-box',

//                     WebkitLineClamp: 2,

//                     WebkitBoxOrient:
//                       'vertical',

//                     overflow: 'hidden',
//                   }}
//                 >
//                   Register as a vendor and grow
//                   your business with us.
//                 </Typography>

//               </Box>


//               {/* ==================================================
//                   VENDOR BUTTON - KEEP ORIGINAL COLORS
//               ================================================== */}

//               <Button
//                 onClick={(e) => {

//                   e.stopPropagation();

//                   navigate('/vendor-form');

//                 }}

//                 variant="contained"

//                 disableElevation

//                 sx={{
//                   flexShrink: 0,

//                   textTransform: 'none',

//                   fontWeight: 600,

//                   fontSize: isMobile
//                     ? '8.5px'
//                     : '9.5px',

//                   borderRadius: '6px',

//                   px: isMobile
//                     ? 1.2
//                     : 1.5,

//                   py: 0.5,

//                   minWidth: isMobile
//                     ? 65
//                     : 72,

//                   whiteSpace: 'nowrap',

//                   bgcolor: '#D49A25',  // KEEP ORIGINAL

//                   color: '#FFFFFF',

//                   boxShadow: '0 2px 5px rgba(180,120,20,0.25)',

//                   '&:hover': {
//                     bgcolor: '#C58B20',  // KEEP ORIGINAL
//                   },
//                 }}
//               >
//                 Register Now
//               </Button>

//             </Paper>

//           </Box>

//         </Stack>

//       </Box>


//       {/* ==================================================
//           BOTTOM NAVBAR
//       ================================================== */}

//       <FormsBottomNavbar />

//     </>
//   );
// };


// export default Forms;



import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  useMediaQuery,
  Paper,
  Button,
  Chip,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import BadgeIcon from '@mui/icons-material/Badge';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';

import { BASE_URL } from '../../Api/ApiUrls';
import newLaunchImg from './../../../../src/Images/post-new-launching.jpeg';

import sellPropertyImg from './../../../../src/Images/post-sell.jpeg';
import rentPropertyImg from './../../../../src/Images/post-rent.jpeg';
import leasePropertyImg from './../../../../src/Images/post-lease.jpeg';
import jdJvImg from './../../../../src/Images/post-jvjd.jpeg';

import requirementsImg from './../../../../src/Images/correctionpad.png';
import bankActionImg from './../../../../src/Images/auction-property.jpeg';
import img1 from './../../../Images/vendorcard.jpg';

import FormsBottomNavbar from './FormsBottomNavbar';
import SearchBar from './PostBack';
import { AuthContext } from '../../AuthContext/AuthContext';

// ======================================================
// FORM OPTIONS
// ======================================================
const options = [
  {
    icon: SellOutlinedIcon,
    centerText: 'Sell Your Property',
    desc: 'List your property for sale and connect with genuine buyers.',
    buttonLabel: 'Post Now',
    path: '/sellyourproperty-form',
    image: sellPropertyImg,
  },
  {
    icon: HomeOutlinedIcon,
    centerText: 'Rent Your Property',
    desc: 'Find the right tenants quickly and rent with ease.',
    buttonLabel: 'Post Now',
    path: '/rent-form',
    image: rentPropertyImg,
  },
  {
    icon: DescriptionOutlinedIcon,
    centerText: 'Lease Your Property',
    desc: 'Lease your residential or commercial property easily.',
    buttonLabel: 'Post Now',
    path: '/lease-form',
    image: leasePropertyImg,
  },
  {
    icon: HandshakeOutlinedIcon,
    centerText: 'Post your JD/JV/Build Suit',
    desc: 'Find partners for Joint Development or Build to Suit projects.',
    buttonLabel: 'Post Now',
    path: '/builder-registration-form',
    image: jdJvImg,
  },
  {
    icon: FactCheckOutlinedIcon,
    centerText: 'Post Your Requirements',
    desc: "Tell us what you need. We'll find the best matches for you.",
    buttonLabel: 'Post Now',
    path: '/pg-hostel-form',
    image: requirementsImg,
  },
  {
    icon: GavelOutlinedIcon,
    centerText: 'Post Bank Auction Properties',
    desc: 'List bank auction and distressed properties.',
    buttonLabel: 'Post Now',
    path: '/post-bank-properties',
    image: bankActionImg,
  },
  {
    icon: WorkspacePremiumOutlinedIcon,
    centerText: 'New Launching Properties\n(Layouts, Villas, Apartment Flats)',
    desc: 'Discover the latest projects from top builders.',
    buttonLabel: 'Post Project',
    featured: true,
    badge: 'NEW',
    specialLabel: 'Best',
    path: '/new-launching-prop-form',
    image: newLaunchImg,
  },
];

// ======================================================
// UI COLORS
// ======================================================
const CARD_BG_FROM = '#FBFAF7';
const CARD_BG_TO = '#F3EEE3';
const GOLD = '#D9A441';
const BADGE_DARK = '#171717';
const CARD_RADIUS = 20;


// ======================================================
// REUSABLE CARD
// ======================================================
const InfoCard = ({ item, isMobile, navigate }) => {
  const Icon = item.icon;
  const isFeatured = !!item.featured;
  const titleLines = item.centerText.split('\n');

  // Fixed heights for better spacing
  const cardHeight = isFeatured ? (isMobile ? 110 : 120) : isMobile ? 95 : 100;
  const iconWidth = 44;
  const imageWidth = isFeatured ? (isMobile ? 110 : 130) : isMobile ? 90 : 110;

  return (
    <Paper
      elevation={0}
      onClick={() => navigate(item.path)}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'stretch',
        width: '100%',
        minWidth: 0,
        height: cardHeight,
        borderRadius: `${CARD_RADIUS}px`,
        overflow: 'hidden',
        // 👇 CHANGED THIS LINE: Replaced gradient with solid white
        backgroundColor: 'white', 
        boxShadow: '0 3px 10px rgba(0,0,0,0.10)',
        transition: 'box-shadow 0.2s ease',
        '&:hover': {
          boxShadow: '0 5px 14px rgba(0,0,0,0.14)',
        },
        position: 'relative',
      }}
    >
      {/* ================= ICON SECTION ================= */}
      <Box
        sx={{
          width: iconWidth,
          minWidth: iconWidth,
          height: '100%',
          bgcolor: BADGE_DARK,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.3,
          flexShrink: 0,
        }}
      >
        <Icon
          sx={{
            color: '#BA915B',
            fontSize: isFeatured ? (isMobile ? 26 : 30) : isMobile ? 22 : 26,
          }}
        />
        {item.specialLabel && (
          <Typography
            sx={{
              color: '#E1B84C',
              fontSize: 9,
              fontWeight: 700,
              letterSpacing: '0.2px',
              lineHeight: 1,
            }}
          >
            {item.specialLabel}
          </Typography>
        )}
      </Box>

      {/* ================= IMAGE SECTION ================= */}
      <Box
        sx={{
          position: 'relative',
          flexShrink: 0,
          width: imageWidth,
          height: '100%',
        }}
      >
        <Box
          component="img"
          src={item.image}
          alt={item.centerText}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            borderTopRightRadius: 30,
            borderBottomRightRadius: 30,
          }}
        />

        {item.badge && (
          <Chip
            label={item.badge}
            size="small"
            sx={{
              position: 'absolute',
              top: 6,
              right: 6,
              height: 18,
              minWidth: 30,
              fontSize: 8,
              fontWeight: 700,
              bgcolor: GOLD,
              color: '#FFFFFF',
              borderRadius: '4px',
              '& .MuiChip-label': {
                px: 0.8,
                py: 0.3,
              },
            }}
          />
        )}
      </Box>

      {/* ================= TEXT SECTION ================= */}
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          px: 1.5,
          py: 1,
        }}
      >
        {titleLines.map((line, i) => (
          <Typography
            key={i}
            sx={{
              fontWeight: 700,
              fontSize: isMobile ? '12px' : '14px',
              color: '#171717',
              lineHeight: 1.3,
              letterSpacing: '-0.1px',
              // whiteSpace: isFeatured ? 'normal' : 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: isFeatured ? 'block' : 'block',
            }}
          >
            {line}
          </Typography>
        ))}

        <Box
          sx={{
            width: 28,
            height: 2.5,
            bgcolor: GOLD,
            borderRadius: 2,
            my: 0.5,
          }}
        />

        {item.desc && (
          <Typography
            sx={{
              fontSize: isMobile ? '9px' : '10px',
              color: '#8A6A3D',
              lineHeight: 1.3,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              maxHeight: isMobile ? '28px' : '32px',
            }}
          >
            {item.desc}
          </Typography>
        )}
      </Box>

      {/* ================= CTA BUTTON ================= */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          px: isMobile ? 1 : 2,
          minWidth: isMobile ? 70 : 90,
        }}
      >
        <Button
          onClick={(e) => {
            e.stopPropagation();
            navigate(item.path);
          }}
          variant="contained"
          disableElevation
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            fontSize: isMobile ? '10px' : '10px',
            borderRadius: '6px',
            px: isMobile ? 1.2 : 2,
            py: 0.8,
            minWidth: isMobile ? 60 : 80,
            whiteSpace: 'nowrap',
            bgcolor: '#BA915B',
            color: '#FFFFFF',
            boxShadow: '0 2px 5px rgba(180,120,20,0.25)',
            '&:hover': {
              bgcolor: '#BA915B',
            },
          }}
        >
          {item.buttonLabel || 'Post Now'}
        </Button>
      </Box>
    </Paper>
  );
};

// ======================================================
// MAIN COMPONENT
// ======================================================

const Forms = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isiPhoneSE = useMediaQuery('(max-width: 376px) and (max-height: 670px)');

  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [missingPlans, setMissingPlans] = useState([]);

  const { userId, logout, isGuest } = useContext(AuthContext);

  const handleBackClick = () => navigate(-1);

  useEffect(() => {
    checkFreePlan();
  }, []);

  const checkFreePlan = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/check-free-plan/${userId}/`);

      if (!res.data.has_free_plan) {
        setMissingPlans(res.data.missing_free_user_types || []);
        setOpenModal(true);
      }
    } catch (error) {
      console.error('Error checking free plan:', error);
    }
  };

  const handleClaim = async () => {
    try {
      await axios.post(`${BASE_URL}/claim-all-free-plans/`, {
        user_id: userId,
      });

      alert('✅ Free plans claimed successfully!');
      setOpenModal(false);
      checkFreePlan();
    } catch (error) {
      console.error('Error claiming free plans:', error);
    }
  };

  const PAGE_BACKGROUND = '#f6f2e9';

  const vendorItem = {
    icon: BadgeIcon,
    centerText: 'Vendors Registration',
    desc: 'Register as a vendor and grow your business with us.',
    buttonLabel: 'Register Now',
    path: '/vendor-form',
    image: img1,
  };

  return (
    <>
      <SearchBar onBackClick={handleBackClick} />

      <Box
        sx={{
          px: isMobile ? 1.5 : 3,
          pt: 2,
          pb: 10,
          mt: 8,
          width: '100%',
          maxWidth: '100%',
          mx: 'auto',
          minHeight: isiPhoneSE ? '100vh' : '82vh',
          backgroundColor: PAGE_BACKGROUND,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          boxSizing: 'border-box',
        }}
      >
        <Stack spacing={1.5}>
          {options.map((item, index) => (
            <InfoCard key={index} item={item} isMobile={isMobile} navigate={navigate} />
          ))}

          <InfoCard item={vendorItem} isMobile={isMobile} navigate={navigate} />
        </Stack>
      </Box>

      <FormsBottomNavbar />
    </>
  );
};

export default Forms;